/* unplugin-vue-components disabled */import { render } from "./IntroGalleryConfirmation.vue?vue&type=template&id=b396a0b0&scoped=true"
import script from "./IntroGalleryConfirmation.vue?vue&type=script&lang=js"
export * from "./IntroGalleryConfirmation.vue?vue&type=script&lang=js"

import "./IntroGalleryConfirmation.vue?vue&type=style&index=0&id=b396a0b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b396a0b0"]])

export default __exports__